export const environmentTypes = {
  GET_ENVIRONMENT: "GET_ENVIRONMENT",
  GET_VERSION: "GET_VERSION",
  GET_PORTAL_STATUS: "GET_PORTAL_STATUS",

  GET_FEATURE_FLAGS_AND_DYNAMIC_CONFIGURATIONS: "GET_FEATURE_FLAGS_AND_DYNAMIC_CONFIGURATIONS",
  GET_ALLOW_IMPERSONATION: "GET_ALLOW_IMPERSONATION",
  GET_ENABLE_VISITOR_BOOKING: "GET_ENABLE_VISITOR_BOOKING",
};
